module.exports = __webpack_public_path__ + "img/img_whenIsUseful3.3924f08d.png";